import { Gift } from 'lucide-react';

/**
 * Merkzeichen für den Geschenkwunsch (A25).
 *
 * WOZU ES HIER OBEN STEHT
 *   Zwischen dem Gespräch, in dem der Wunsch fällt, und dem Packtisch
 *   liegen Tage und oft ein Schichtwechsel. Wer die Bestellung öffnet,
 *   soll es sehen, bevor er irgendetwas anderes liest — nicht erst,
 *   wenn er unten den Sendungs-Dialog aufmacht.
 *
 * WARUM GOLD UND NICHT CORAL
 *   Ein Geschenkwunsch ist keine Warnung. Er gehört zur gleichen
 *   Familie wie das Übungs-Merkzeichen daneben: erkennbar, ohne die
 *   Aufmerksamkeit zu binden. Dieselbe Gold-Auszeichnung trägt schon
 *   das Geschenk-Zeichen an der Sendungskarte, und das ist Absicht —
 *   Wunsch und Ausführung sehen verwandt aus, weil sie es sind.
 *
 * WARUM DER TEXT TROTZDEM NICHT GOLD IST — gemessen
 *   Die erste Fassung übernahm die Farben des Übungs-Merkzeichens eins zu
 *   eins: gold-dark (#8A7A4A) auf gold-soft (#F2EBD9). Im laufenden Build
 *   nachgerechnet ergibt das 3,56:1, und die Untergrenze für Text liegt
 *   bei 4,5:1 — bei 12 Pixeln ist das kein Feinschliff. Der Text steht
 *   deshalb in Ink (#2B2B2B): 11,91:1. Das Symbol bleibt gold (3,56:1;
 *   für Grafik gelten 3:1), der Rahmen ebenfalls — er trägt keine
 *   Auskunft, sondern fasst sie ein.
 *
 *   Dafür wurde keine neue Farbe erfunden; beide Werte stehen längst in
 *   der Palette.
 *
 * Die Beschriftung steht als Text daneben, nicht nur im `title`: auf dem
 * Tablet gibt es kein Hover, und ein Symbol allein ist keine Auskunft.
 */
export function GeschenkBadge() {
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full border border-gold bg-gold-soft px-2 py-0.5 text-xs text-ink"
      title="Bei der Aufnahme als Geschenk gewünscht. Was daraus wird, steht an der Sendung."
    >
      <Gift aria-hidden className="h-3 w-3 text-gold-dark" />
      Geschenk
    </span>
  );
}
